/* 
 * Wraps a form layout and adds helpful method for form manipulation
 */

/* global customElements */
import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {BaseComponent} from '../basecomponent.js';
import {TimeUtil} from '../../utils/timeUtil.js';

class FormPanel extends BaseComponent {
	
	constructor() {	
		super();
	}
	
	render() {	
		return html`<slot></slot>`;
	}
	
	load(record, options) {
		populateFormChildNodes(this.childNodes, record, options);
	}
	
	isValid() {
		var formPanel = this;
		
		var valid = true;		
		var checkValid = function(childNodes){
			Array.from(childNodes).forEach(function(child){
				if (child.tagName === 'VAADIN-DATE-TIME-PICKER'){
					if (valid && child.required && !child.value) {
						valid = false;
						child.invalid = true;
						child.errorMessage = 'Required';
					}
				} else if (child.tagName === 'VAADIN-DATE-TIME-PICKER-DATE-PICKER' || child.tagName === 'VAADIN-DATE-TIME-PICKER-TIME-PICKER'){
					//ignore
				}else {
					if (child.validate && valid) {
						// Keep prior failures; do not let a later true overwrite false.
						if (!child.validate()) {
							valid = false;
						}
					}	
				}
				//skip child nodes of date time picker since the validation is not defined for individual components vaadin V24
				if (child.tagName !== 'VAADIN-DATE-TIME-PICKER'){
					checkValid(child.childNodes);
				}
			});
		};
		checkValid(formPanel.childNodes);	
		
		return valid;
	}
	
	markFields(errorResponse) {
		var formPanel = this;
		
		var doMarking = function(childNodes){
			Array.from(childNodes).forEach(function(child){
				if (child.name) {
					if (errorResponse[child.name]) {
						child.errorMessage = errorResponse[child.name];
						child.invalid = true;
					}			
				}
				doMarking(child.childNodes);
			});
		};
		doMarking(formPanel.childNodes);
		
	}
	
	getData(options) {
		var formPanel = this;
		
		var data = {};
		
		var pullData = function(childNodes){
			Array.from(childNodes).forEach(function(child){
				if (child.name) {
					if (child.tagName === 'VAADIN-CHECKBOX' || 
						(child.tagName === 'INPUT' && child.type === 'checkbox') 
						) {
						//correct to true
						if (child.checked) {
							data[child.name] = child.checked;						
						} else {
							data[child.name] = false;
						}
					} else if (child.tagName === 'VAADIN-DATE-PICKER' && child.value) { 
						data[child.name] = TimeUtil.formatDateForDateOnlySave(child.value);
					} else if (child.tagName === 'VAADIN-DATE-TIME-PICKER' && child.value) { 
						
						//var dataTime = TimeUtil.parseDate(child.value).toISOString();
						//dataTime = dataTime.replace('.000', '');
						
						var rawDate = child.value;
						if (rawDate && rawDate.endsWith('00:0:0')) {
							rawDate = rawDate.replace('00:0:0', '00:00:00');
						}
						
						var userTime = TimeUtil.parseDate(rawDate);
						var timeZoneFull = TimeUtil.getCompanyTimeZone(userTime);
						if (options && options.timeZone) {
							timeZoneFull = TimeUtil.getFullTimeZone(options.timeZone, userTime);
						}
						var fullDateValue = rawDate + timeZoneFull.offset;
						data[child.name] = TimeUtil.parseDate(fullDateValue).toISOString();
					} else {
						if (child.getCustomValue) {
							data[child.name] = child.getCustomValue();
						} else {
							//check to see if it see if the field is already set
							//the field has both a vaadin tag and input as of version 23
							//...so changes are getting overridden
							if (!data[child.name]) {
								data[child.name] = child.value;	
							}
						}
					}
				}
				pullData(child.childNodes);
			});
		};
		pullData(formPanel.childNodes);		
				
		return data;
	}
	
	clearFields() {
		var formPanel = this;

		var pullData = function(childNodes){
			Array.from(childNodes).forEach(function(child){
				if (child.name) {
					if (child.tagName === 'VAADIN-CHECKBOX' || 
						(child.tagName === 'INPUT' && child.type === 'checkbox') 
						) {
						child.checked = false;					
					} else if (child.tagName === 'VAADIN-DATE-PICKER' && child.value) { 
						child.value = null;						
					} else if (child.tagName === 'VAADIN-DATE-TIME-PICKER' && child.value) { 
						child.value = null;
					} else {
						child.value = null;
					}
				}
				pullData(child.childNodes);
			});
		};
		pullData(formPanel.childNodes);		
	}
	
	submitForm(handler) {
		var formPanel = this;			
			
		if (formPanel.isValid()){
			
			var dataOptions = null;			
			if (handler.timezone) {
				dataOptions = {};
				dataOptions.timeZone = handler.timezone;
			}
			
			var data = formPanel.getData(dataOptions);
			if (handler.preSubmit) {
				var returnData = handler.preSubmit(data);
				if (returnData) {
					data = returnData;
				}
			}
			
			//This is expecting a promise
			//most response should be json with a common error format
			var formPanelMask = formPanel.showLoading(handler.maskMessage || 'Saving...');
			handler.actualCall(data).then(function(decodedResponse){
				formPanelMask.remove();
				if (!decodedResponse) {
					if (handler.responseFail) {
						handler.responseFail(data);
					} else {
						window.DL.MessageUtil.showToastError('Submisson failed on server.');
					}
				} else {				
					if (decodedResponse.success === false) {
						if (handler.fail) {
							handler.fail(data, decodedResponse);
						}
						formPanel.markFields(decodedResponse.errors);
					} else {
						if (handler.success) {
							handler.success(data, decodedResponse);
						}
					}
				}
			}).catch(function(failedResponse) {
				formPanelMask.remove();
				if (handler.fail) {
					handler.fail(data, failedResponse);
				}
			});
		
		} else {
			if (handler.clientValidationFail) {
				handler.clientValidationFail(data);
			} else {
				window.DL.MessageUtil.showToastError('Invaild form; Check Values');
			}
		}			
		
	}
		
};

function populateFormChildNodes(childNodes, record, options) {
	var actualLoad = function(nodes) {
		Array.from(nodes).forEach(function(child) {

			//vaadin-checkboxes have strange behavior with names on loading
			//basically it doesn't have name unless checked 
			//which at load time most of the time it's unchecked
			//this corrects for that
			if (child.tagName === 'VAADIN-CHECKBOX') {
				if (child.getAttribute('name')) {
					if (record[child.getAttribute('name')] && record[child.getAttribute('name')] !== 'false') {
						child.checked = record[child.getAttribute('name')];
					} else {
						child.checked = false;
					}
				}
			} else if (child.tagName === 'VAADIN-DATE-PICKER') {
				if (child.name) {
					if (record[child.name]) {
						if (record[child.name]) {
							var dateValue = TimeUtil.formatDateForDateLoad(record[child.name]);
							child.value = dateValue;
						}
					}
				}
			} else if (child.tagName === 'VAADIN-DATE-TIME-PICKER') {
				if (child.name) {
					if (record[child.name]) {
						if (record[child.name]) {
							var dateTimeValue = TimeUtil.formatDateForDateTimeLoad(record[child.name]);
							child.value = dateTimeValue;
						}
					}
				}
			} else if (child.tagName === 'VAADIN-NUMBER-FIELD') {
				if (child.name) {
					//0 = false so it doesn't populate
					if (record[child.name] !== undefined && record[child.name] !== null) {
						child.value = record[child.name];
					}
				}
			} else {
				if (child.name) {
					if (record[child.name]) {
						if (child.setCustomValue) {
							child.setCustomValue(record[child.name]);
						} else {
							//The form tag wrap an input field and setting that directly causes issues
							if (child.parentElement.tagName !== 'VAADIN-DATE-PICKER') {
								child.value = record[child.name];
							}
						}
					}
				}
			}

			//Combo box don't select value on the set of the value the second time (observed on v23)
			if (options && options.refreshComponents) {
				if (child.name) {
					child.focus();
					child.blur();

					if (!options.noValidate) {
						if (child.validate) {
							child.validate();
						}
					}
				}
			}

			actualLoad(child.childNodes);
		});
	};
	actualLoad(childNodes);
}

/**
 * Applies {@link FormPanel#load} field values under rootElement (e.g. a vaadin-form-layout).
 */
export function populateFormFields(rootElement, record, loadOptions) {
	if (!rootElement || !record) {
		return;
	}
	populateFormChildNodes(rootElement.childNodes, record, loadOptions);
}

customElements.define('dl-form-panel', FormPanel);